import { Box, Typography } from '@mui/material';
import DirectionsBoatOutlinedIcon from '@mui/icons-material/DirectionsBoatOutlined';
import { Fragment } from 'react';
import { Device } from './types';
import { DeviceCheckbox } from './DeviceCheckbox';

interface Barge {
  name: string;
  devices: Device[];
}

interface DeviceListProps {
  barges: Barge[];
  selectedDevices: Device[];
  onDeviceChange: (device: Device) => void;
}

export const DeviceList = ({ barges, selectedDevices, onDeviceChange }: DeviceListProps) => {
  return (
    <Box
      className="devices-list"
      sx={{
        height: '100%',
      }}
    >
      {barges.map((barge, index) => (
        <Fragment key={barge.name}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              pl: '2px',
              mb: '12px',
            }}
          >
            <DirectionsBoatOutlinedIcon fontSize="small" sx={{ width: '15px' }} />
            <Typography
              sx={{
                pl: 1,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                maxWidth: '230px', // Leave space for icon
              }}
            >
              {barge.name}
            </Typography>
          </Box>
          {barge.devices.length > 0 &&
            barge.devices.map((device) => (
              <Box sx={{ mb: '8px' }} key={device.id}>
                <DeviceCheckbox
                  device={device}
                  bargeName={barge.name}
                  isChecked={selectedDevices.some((d) => d.id === device.id)}
                  onChange={onDeviceChange}
                />
              </Box>
            ))}
          {index < barges.length - 1 && (
            <Box sx={{ borderBottom: '1px solid', borderColor: 'divider', my: '12px' }} />
          )}
        </Fragment>
      ))}
    </Box>
  );
};
